/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { createSelector } from 'reselect';

export const getSession = (state) => state.session;

export const getAppEntryPoint = createSelector(getSession, (session) => {
  const { appEntryPoint } = session || {};
  if (appEntryPoint) {
    return appEntryPoint;
  }
  return null;
});

export const isDashboardEntryPoint = createSelector(
  getAppEntryPoint,
  (entryPoint) => entryPoint === '/' || entryPoint === '' // no longer includes actual /dashboard due to valid entry point change
);

export const getApiKey = createSelector(
  getSession,
  (session) => session.apiKey
);

export const getQueryParams = createSelector(
  getSession,
  (session) => session.query.params
);

export const hasComposeQueryParam = createSelector(
  getQueryParams,
  (params) => params && params['compose'] === 'true'
);

export const isMainMenuVisible = createSelector(
  getQueryParams,
  (params) => params && params['mobile'] !== '1'
);

export const isContextualNavVisible = createSelector(
  getQueryParams,
  (params) => params && params['mobile'] !== '1'
);

export const getVendorSessions = createSelector(
  getSession,
  (session) => session.vendorSessions
);

export const getActiveVendorSessions = createSelector(
  getVendorSessions,
  (vendorSessions) =>
    vendorSessions.filter((session) => session && session.active)
);
